<template>
	<div class="page-not-found">
		<h1>404</h1>
		<h3>{{ $t('404.page_not_found') }}</h3>
		<router-link to="/">{{ $t('button.home') }}</router-link>
	</div>
</template>

<script>
	export default {
		name: 'page-not-found',
			data() {
				
			}
	}
</script>
